import React from "react";
import PropTypes from "prop-types";

import Confirmation from "settings/components/Confirmation";
import ReducedTagRow from "settings/components/TagRow/ReducedTagRow";

import styles from "./MergeTagsConfirmation.css";

export default function MergeTagsConfirmation({
  tags,
  selectedTag,
  onClick,
  wasClicked,
  onCancel,
}) {
  const { selected, rest } = tags.reduce(
    (sorted, tag) => {
      if (tag.id === selectedTag.value) {
        sorted.selected = tag;
      } else {
        sorted.rest.push(tag);
      }
      return sorted;
    },
    { selected: null, rest: [] }
  );

  return (
    <Confirmation
      header="Are you sure you want to merge these tags?"
      clickText="Yes, merge and delete"
      onClick={onClick}
      onCancel={onCancel}
      wasClicked={wasClicked}
    >
      <div className={styles.container}>
        <p className={styles.info}>
          {tags.length > 2 ? "These tags" : "This tag"} will be permanently
          deleted:
        </p>
        {rest.map(tag => (
          <ReducedTagRow tag={tag} key={tag.id} className={styles.warning} />
        ))}
      </div>

      <div className={styles.container}>
        <p className={styles.info}>And merged into this tag:</p>
        <ReducedTagRow tag={selected} />
      </div>
    </Confirmation>
  );
}

MergeTagsConfirmation.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedTag: PropTypes.shape({
    value: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  wasClicked: PropTypes.bool.isRequired,
};
